import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = { class: "class-block__header" }
const _hoisted_3 = { class: "font-weight-bold" }
const _hoisted_4 = { class: "table-container" }
const _hoisted_5 = { class: "usages-headers" }
const _hoisted_6 = { class: "usages-header col-name" }
const _hoisted_7 = { class: "usages-item col-name" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_month_pager = _resolveComponent("month-pager")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_month_pager, {
        modelValue: _ctx.yearMonth,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearMonth) = $event)),
          _ctx.pageClick
        ]
      }, null, 8, ["modelValue", "onUpdate:modelValue"])
    ]),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "my-4"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classesWithUsages, (cwu) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "class-block",
        key: cwu.class.classId
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(cwu.class.className), 1),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "text",
            to: `/school-service/usage/${cwu.class.classId}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common_actions.monthlyUsageConfirmation')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('common.name')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolServices, (service) => {
              return (_openBlock(), _createElementBlock("div", {
                key: service.uniqueServiceId,
                class: "usages-header col-item"
              }, _toDisplayString(service.uniqueServiceName), 1))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cwu.usages, (usage) => {
            return (_openBlock(), _createElementBlock("div", {
              key: usage.child.childId,
              class: "usages-row",
              style: _normalizeStyle({ width: `${_ctx.tableWidth}px` })
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(usage.child.lastName) + " " + _toDisplayString(usage.child.firstName), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usage.services, (service) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: service.service.uniqueServiceId,
                  class: "usages-item col-item",
                  onClick: ($event: any) => (_ctx.toggleUsage(service, usage.child))
                }, [
                  (service.hasUsed)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        color: "primary",
                        size: "x-large"
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("mdi-checkbox-marked", -1)
                        ]))]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        color: "#c8c8c8",
                        size: "x-large"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-checkbox-blank-outline", -1)
                        ]))]),
                        _: 1
                      }))
                ], 8, _hoisted_8))
              }), 128))
            ], 4))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}